// Utility to fetch employee data from Firestore by name (case-insensitive, contains)
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../firebase';


/**
 * Searches for employees in Firestore by name (case-insensitive, contains)
 * @param {string} name - the name to search for
 * @returns {Promise<Array<{id: string, ...EmployeeData}>} - an array of employee objects from Firestore
 */
export async function searchEmployeesByName(name) {
  if (!name || name.length < 2) return [];
  // Firestore does not support 'contains' natively, so we fetch and filter client-side
  const employeesRef = collection(db, 'employees');
  const snapshot = await getDocs(employeesRef);
  const lowerName = name.toLowerCase();
  return snapshot.docs
    .map(doc => ({ id: doc.id, ...doc.data() }))
    .filter(emp => emp.employeesName && emp.employeesName.toLowerCase().includes(lowerName));
}
